import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UploadFile from '@/components/upload/uploadFile';
import formHelpers from './utils/form';
import SectionEditActions from './SectionEditActions';
export default {
  name: 'BiddingSupportTab',
  components: {
    UploadFile: UploadFile,
    SectionEditActions: SectionEditActions
  },
  mixins: [formHelpers],
  props: {
    formData: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: 'add'
    },
    editSaving: {
      type: Boolean,
      default: false
    },
    bidSupportPersonList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isTaskFormDisabled: {
      type: Function,
      required: true
    },
    isEditingTask: {
      type: Function,
      required: true
    },
    isViewTaskDisabled: {
      type: Function,
      required: true
    },
    showProjectInfoEditButton: {
      type: Function,
      required: true
    },
    startProjectInfoEdit: {
      type: Function,
      required: true
    },
    confirmProjectInfoEdit: {
      type: Function,
      required: true
    },
    cancelProjectInfoEdit: {
      type: Function,
      required: true
    }
  },
  methods: {
    handleCheckPersonChange: function handleCheckPersonChange() {
      var biddingSupport = this.formData.items.bidding_support;
      var selected = this.bidSupportPersonList.find(function (item) {
        return String(item.id) === String(biddingSupport.check_person_id);
      });
      biddingSupport.check_person_name = selected ? selected.name : '';
    },
    handleBidFileUploaded: function handleBidFileUploaded(key, url, fileName, uid) {
      var fileItem = {
        file_name: fileName,
        url: key,
        is_delete: 0
      };
      this.formData.items.bidding_support.bid_files.push(fileItem);
    },
    handleBidFileRemoved: function handleBidFileRemoved(file) {
      var index = this.formData.items.bidding_support.bid_files.findIndex(function (item) {
        return item.uid === file.uid;
      });
      if (index > -1) {
        this.formData.items.bidding_support.bid_files.splice(index, 1);
      }
    },
    deleteBidFile: function deleteBidFile(index) {
      this.formData.items.bidding_support.bid_files.splice(index, 1);
    }
  }
};